export default __webpack_public_path__ + "static/media/Group 8 (1).b47aa8e7.png";